export default __webpack_public_path__ + "static/14-ef18dbca90d87f1ebabcfd5db99b9bcc.jpg";